import styled from 'styled-components';
import { code } from '../Pre/Pre';
var Code = styled('code').withConfig({
  displayName: "Code",
  componentId: "sc-khv0m0-0"
})(code);
export default Code;